export default __webpack_public_path__ + "static/isos-3f8dec2cd67af5ff09fb7959a48675db.png";